import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import flatten from 'flat';
import { useEffect } from 'react';
import { IntlProvider } from 'react-intl';
import { ThemeProvider } from 'react-jss';

import Layout from 'layout';
import { useDispatch, useSelector } from 'hooks';
import { appStateActions, authActions } from 'configs';
import messages from 'translations';

import { BrowserRouter, Grid, PreLoader } from 'components';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60,
    },
  },
});

const theme = {
  label_font_weight: 500,
};

const App = () => {
  const breakpoint = Grid.useBreakpoint();
  const dispatch = useDispatch();

  const authenticating = useSelector((state) => state.auth.authenticating);

  useEffect(() => {
    dispatch(authActions.authenticateStart());
  }, [dispatch]);

  useEffect(() => {
    dispatch(appStateActions.setBreakpoints(breakpoint));
  }, [breakpoint, dispatch]);

  return (
    <ThemeProvider theme={theme}>
      <IntlProvider locale='en' messages={flatten(messages.en)}>
        <QueryClientProvider client={queryClient}>
          <ReactQueryDevtools initialIsOpen={false} />
          <BrowserRouter>
            {authenticating ? <PreLoader size='large' /> : <Layout />}
          </BrowserRouter>
        </QueryClientProvider>
      </IntlProvider>
    </ThemeProvider>
  );
};

export default App;
